module.exports = __webpack_public_path__ + "static/img/ThumbnailPlaceholder.651bca55.jpg";